module.exports = __webpack_public_path__ + "img/jgsjg.473422a9.png";